import generateId from '@/utils/generateId'
import { Logs } from '.'
import { v2Host } from '@/config/host'

export const ptLogs = new Logs({
  baseUrl: 'https://playable-stats.mintegral.net/pt',
  env: process.env.NODE_ENV === 'production' ? 'p' : 't',
  sid: generateId(),
  v: process.env.TAG,
  tp: 'pt',
  autoPv: false,
})

export const ptTrackEvent = new Logs({
  baseUrl: `${v2Host}/track/event`,
  env: process.env.NODE_ENV === 'production' ? 'p' : 't',
  sid: generateId(),
  v: process.env.TAG,
  tp: 'pt',
  autoPv: false,
  autoFp: false,
})
